import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { createTheme, ThemeProvider } from "@mui/material";
import Home from "./pages/Home";
import Imprint from "./pages/Imprint";

const theme = createTheme({
  typography: {
    fontFamily: '"Poppins", serif',
  },
  palette: {
    primary: {
      main: "#c9179a",
    },
    secondary: {
      main: "#e6d3a2",
    },
    text: {
      primary: "#e6d3a2",
      secondary: "#e6d3a2",
    },
    background: {
      paper: "#6e3224",
    },
  },
  components: {
    MuiInputLabel: {
      styleOverrides: {
        root: {
          fontSize: "14px", // Changes input text size
        },
      },
    },
    MuiInput: {
      styleOverrides: {
        root: {
          //height: 20,
          fontSize: "14px", // Changes input text size
          color: "#e6d3a2",
          "&:before": { borderBottom: "1px solid #e6d3a2" }, // Normal state
          "&:hover:not(.Mui-disabled):before": {
            borderBottom: "1px solid #e6d3a2",
          }, // Hover
          "&:after": { borderBottom: "1px solid #c9179a" }, // Focused
        },
      },
    },
    MuiSelect: {
      styleOverrides: {
        icon: {
          color: "#e6d3a2",
        },
      },
    },
    MuiTypography: {
      styleOverrides: {
        root: {
          color: "#e6d3a2",
          textAlign: "left",
          fontSize: 12,
        },
      },
    },
  },
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <Router>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/imprint" element={<Imprint />} />
        </Routes>
      </Router>
    </ThemeProvider>
  );
}

export default App;
